module.exports = __webpack_public_path__ + "static/media/Nonord-Y-A-trial-Skjofenal.d5f91daf.mp3";